module.exports = {
    "crude": {
        "search": "Zoeken",
        "actions": "Acties",
        "nextPage": "Volgende bladzijde",
        "lastPage": "Vorige bladzijde",
        "back": "Rug",
        "empty": "leeg",
        "edit": "bewerking",
        "create": "creëren",
        "data": "dossier",
        "view": "show",
        "delete": "Verwijderen",
        "save": "Redden",
        "cancel": "Annuleren",
        "noContent": "Geen vermeldingen beschikbaar. ",
        "resetFilter": "Reset de filters en bekijk meer inhoud!",
        "createOwnTextField": "Maak uw eigen tekstveld",
        "textFieldName": "tekstveldlabel",
        "textFieldValue": "Inhoud",
        "insertTextFieldLabel": "Voer de naam van het tekstveld in!",
        "deleteTextField": "Tekstveld verwijderen",
        "success": "Het opslaan is gelukt",
        "invalidDataFields": "De volgende gegevensvelden zijn ongeldig:  ",
        "entries": "inzendingen",
        "entry": "binnenkomst",
        "tabDetail": "details",
        "entity": "entiteit",
        "of": "van",
        "uploadNewFile": "Upload bestand",
        "upload": "uploaden",
        "confirm": "OK",
        "deleteFileQuestion": "Wilt u dit bestand echt verwijderen? ",
        "deleteFileQuestionTitle": "Gevaar!",
        "deleteEntityQuestion": "Wilt u deze entiteit echt verwijderen? ",
        "deleteEntityQuestionTitle": "Gevaar!",
        "errorLargeFileUpload": "Het geselecteerde bestand is te groot!",
        "useCroppedImage": "Gebruik bijsnijden",
        "useOriginalImage": "Gebruik originele afbeelding",
        "available": "beschikbaar",
        "searchColumn": "kolom vinden",
        "manageColumns": "Kolommen beheren",
        "hideColumn": "kolom verbergen",
        "pinToRight": "Zet de kolom aan de rechterkant vast",
        "pinToLeft": "Kolom links vastzetten",
        "sortAsc": "Sorteer oplopend",
        "sortDesc": "Sorteer aflopend",
        "hideAll": "alles verbergen",
        "showAll": "Toon alles",
        "preview": "voorbeeld",
        "title": "titel",
        "description": "Beschrijving",
        "tooltip": "tooltip",
        "sort": "sorteer op",
        "settings": "Instellingen",
        "incomingReference": "referentie",
        "language": "Taal",
        "deleteTabQuestionTitle": "Gevaar!",
        "deleteTabQuestion": "Wilt u dit tabblad echt verwijderen? ",
        "deleteElementQuestionTitle": "Gevaar!",
        "deleteElementQuestion": "Wilt u dit item echt verwijderen? ",
        "configurationEditorDescriptionStringLayout": "In deze kolom kunnen drie varianten worden geselecteerd voor het invoeren van de tekst:",
        "configurationEditorDescriptionEnumLayout": "Voor de selectie van de elementen in deze kolom kunnen twee varianten worden geselecteerd:",
        "configurationEditorDescriptionBooleanLayout": "Voor de selectie van de elementen in deze kolom kunnen twee varianten worden geselecteerd:",
        "configurationEditorDescriptionForeignEntityLayout": "Voor de selectie van de elementen in deze kolom kunnen twee varianten worden geselecteerd:",
        "stringLayoutsingleline": "enkele lijn",
        "stringLayoutmultiline": "meerdere regels",
        "stringLayouteditor": "Rich Text-editor",
        "enumLayoutradio": "Radio knop",
        "enumLayoutdropdown": "laten vallen",
        "booleanLayoutcheckbox": "selectievakje",
        "booleanLayoutswitch": "schakelaars",
        "foreignEntityLayoutpopUp": "pop-up",
        "foreignEntityLayoutautocomplete": "laten vallen",
        "foreignEntityLayoutlist": "lijst",
        "formatTooltipbold": "Vet",
        "formatTooltipitalic": "cursief",
        "formatTooltipunderline": "onderstreept",
        "formatTooltipstrike": "Doorgestreept",
        "formatTooltipclean": "heldere opmaak",
        "formatTooltipcodeBlock": "code",
        "formatTooltipblockquote": "Citaat",
        "formatTooltipcolor": "lettertype kleur",
        "formatTooltipbackground": "Achtergrond kleur",
        "formatTooltipfont": "lettertype",
        "formatTooltipalign": "uitlijning",
        "formatTooltipheader": "lettertypegrootte",
        "formatTooltipsuper": "Superscript",
        "formatTooltipsub": "onderschrift",
        "formatTooltipordered": "Bestelde lijst",
        "formatTooltipbullet": "Opsomming",
        "true": "Ja",
        "false": "Nee",
        "selectEntity": "entiteit selecteren",
        "filter": "filter",
        "useFilter": "Pas filters toe",
        "defaultFilter": "filter opnieuw instellen",
        "expand": "uitbreiden",
        "hide": "verbergen",
        "minimumSelectionError": "Er moeten minimaal {{min}} vermeldingen worden geselecteerd.",
        "maximumSelectionError": "Er kunnen maximaal {{max}} inzendingen worden geselecteerd."
    }
}
;